
export const normalizeGuid = (guid: string): string => {
    if (!guid || !guid.toLowerCase) return guid;
    return guid.toLowerCase().replace(/-/g, '');
};

